import {
  Bed,
  BookOutlined,
  ChildFriendlyOutlined,
  CoffeeOutlined,
  ExtensionOutlined,
  FitnessCenter,
  FlareOutlined,
  FoodBankOutlined,
  HomeOutlined,
  NatureOutlined,
  NotificationsOutlined,
  SelfImprovement,
  SmokeFree,
  SportsTennis,
  StadiumOutlined,
  Water,
} from '@mui/icons-material'
import type { ParseKeys } from 'i18next'
import { type JSX } from 'react'

type configType = {
  title: ParseKeys<'network.career_website'>
  items: {
    customIcon: JSX.Element
    itemId: string
    label: ParseKeys<'network.career_website'>
  }[]
}[]

export const benefitsList: configType = [
  {
    title: 'benefits.list.healthCare.title',
    items: [
      {
        customIcon: <SportsTennis />,
        itemId: 'sports_activities',
        label: 'benefits.list.healthCare.slot1',
      },
      {
        customIcon: <Bed />,
        itemId: 'rest_room',
        label: 'benefits.list.healthCare.slot2',
      },
      {
        customIcon: <SmokeFree />,
        itemId: 'smoke_free',
        label: 'benefits.list.healthCare.slot3',
      },
      {
        customIcon: <FitnessCenter />,
        itemId: 'fitness_room',
        label: 'benefits.list.healthCare.slot4',
      },
      {
        customIcon: <SelfImprovement />,
        itemId: 'wellness_programs',
        label: 'benefits.list.healthCare.slot5',
      },
    ],
  },
  {
    title: 'benefits.list.family.title',
    items: [
      {
        customIcon: <CoffeeOutlined />,
        itemId: 'break_room',
        label: 'benefits.list.family.slot1',
      },
      {
        customIcon: <NotificationsOutlined />,
        itemId: 'flexible_hours',
        label: 'benefits.list.family.slot2',
      },
      {
        customIcon: <ChildFriendlyOutlined />,
        itemId: 'childcare',
        label: 'benefits.list.family.slot3',
      },
      {
        customIcon: <FoodBankOutlined />,
        itemId: 'cafeteria',
        label: 'benefits.list.family.slot4',
      },
      {
        customIcon: <HomeOutlined />,
        itemId: 'remote_work',
        label: 'benefits.list.family.slot5',
      },
    ],
  },
  {
    title: 'benefits.list.environment.title',
    items: [
      {
        customIcon: <NatureOutlined />,
        itemId: 'green_spaces',
        label: 'benefits.list.environment.slot1',
      },
      {
        customIcon: <Water />,
        itemId: 'water_fountain',
        label: 'benefits.list.environment.slot2',
      },
    ],
  },
  {
    title: 'benefits.list.hobbies.title',
    items: [
      {
        customIcon: <StadiumOutlined />,
        itemId: 'sports_events',
        label: 'benefits.list.hobbies.slot1',
      },
      {
        customIcon: <BookOutlined />,
        itemId: 'library',
        label: 'benefits.list.hobbies.slot2',
      },
      {
        customIcon: <FlareOutlined />,
        itemId: 'team_events',
        label: 'benefits.list.hobbies.slot3',
      },
      {
        customIcon: <ExtensionOutlined />,
        itemId: 'games_room',
        label: 'benefits.list.hobbies.slot4',
      },
    ],
  },
]
